<template>
    <div class="page-container" :class="{'has-breadcrumb': profile.isSharpAdmin()}" >
        <div class="px-8 md:px-5 py-5 " v-if="profile.isSharpAdmin()" >
            <breadcrumb></breadcrumb>
        </div>

        <div class="px-8 md:px-5 py-5 ">
            <h1 class="mb-6">
                Devices
            </h1>
            <admin-equipment-grid
                    title="All devices managed by this account"
            ></admin-equipment-grid>
        </div>
    </div>
</template>

<script charset="utf-8">
    import Vuex from 'vuex';
    import AdminEquipmentGrid from './includes/AdminEquipmentGrid.vue';
    import Breadcrumb from './includes/Breadcrumb.vue';

    export default {
        name: 'ClientsDevice',

        components: {
            AdminEquipmentGrid,
            Breadcrumb
        },

        created: function () {
            this.getClient({ clientID: this.$router.currentRoute.value.params.clientID}).then(data => {
                this.setPaths([
                    {
                        text: 'Sharp Admin',
                        name: 'adminClients'
                    },
                    {
                        text: data.name,
                        name: 'adminDevice',
                        params: { clientID: data.id }
                    },
                    {
                        text: 'Devices',
                        isText: true
                    },
                ]);
            });
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
        },

        methods: {
            ...Vuex.mapActions('accounts', {
                getClient: 'getClient'
            }),
            ...Vuex.mapMutations('layout', {
                setPaths: 'setPaths',
            })
        }
    }
</script>
